/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable indent */
/* eslint-disable operator-linebreak */
/* eslint-disable import/prefer-default-export */

import {
  GameVariableBookTemplateValues,
  PageRestitution,
  VariableRestitution,
} from '@orientaction/types';
import { AppThunk } from '../store';

export const updateField =
  (field: string, value: unknown): AppThunk =>
  dispatch => {
    dispatch({
      type: 'UPDATE_FIELD',
      payload: { field, value },
    });
  };

export const resetValues = (): AppThunk => dispatch => {
  dispatch({
    type: 'RESET_VALUES',
  });
};

export const setAllValues =
  (payload: Partial<GameVariableBookTemplateValues>): AppThunk =>
  dispatch => {
    dispatch({
      type: 'SET_ALL_VALUES',
      payload,
    });
  };

export const setAllVariables =
  (payload: VariableRestitution[]): AppThunk =>
  dispatch => {
    dispatch({
      type: 'SET_ALL_VARIABLES',
      payload,
    });
  };

export const resetValuesModel = (): AppThunk => dispatch => {
  dispatch({
    type: 'RESET_VALUES_MODEL',
  });
};

export const setAllValuesModel =
  (payload: Partial<GameVariableBookTemplateValues>): AppThunk =>
  dispatch => {
    dispatch({
      type: 'SET_ALL_VALUES_MODEL',
      payload,
    });
  };

export const setPageRestitution =
  (payload: PageRestitution[]): AppThunk =>
  dispatch => {
    dispatch({
      type: 'SET_PAGE_RESTITUTION',
      payload,
    });
  };
